import React from 'react';
import { Text } from 'library';
import { styled, Grid } from '@mui/material';
import { ExplanatoryCredentialPill } from '../ExplanatoryCredentialPill';

export function BaseCredentials() {
    return (
        <Grid container style={{ marginTop: 3 }}>
            <Grid container item xs={12}>
                <Text variant="body2">• Pennsylvania State Police Background Check</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Pennsylvania Child Abuse History Certification</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• National Sex Offender Registry Clearance</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• FBI Fingerprint Background Check</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Two character references</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Verified high school education</Text>
            </Grid>
            <Grid container item xs={12}>
                <Text variant="body2">• Completed medical form</Text>
            </Grid>
            <ExplanatoryCredentialPill
                label="Forms as Required by Pennsylvania Department of Human Services"
                title={
                    <Hover>
                        <Text variant="caption" bold>
                            Required Documents
                        </Text>
                        <Text variant="caption">- Disclosure Statement for Child Care Employment</Text>
                        <Text variant="caption">- Staff Health Assessment/Medical Report</Text>
                        <Text variant="caption">- TB Test Records</Text>

                        <Text variant="caption" bold>
                            Trainings on state timeline
                        </Text>
                        <Text variant="caption">- Health and Safety Training</Text>
                        <Text variant="caption">- Mandated Reporter Training</Text>
                        <Text variant="caption">- First Aid/CPR Training</Text>
                    </Hover>
                }
            />
        </Grid>
    );
}

const Hover = styled('div')({
    padding: 5,
});
